<!-- MAINTENANCE PLANS PRIMENG DATATABLE -->
<p-table
	[value]="paginationResult.entities"
	[lazy]="true"
	(onLazyLoad)="loadData($event)"
	[rows]="paginationRequest.pageSize"
	[totalRecords]="paginationResult.filteredEntities"
	[rowsPerPageOptions]="[10, 20, 30, 40, 50]"
	[paginator]="true"
	[(selection)]="selectedEntities"
	[loading]="loading"
	[rowHover]="true"
	[showCurrentPageReport]="true"
	dataKey="name"
	currentPageReportTemplate="{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
	class="custom-table"
	styleClass="p-datatable-striped"
>
	<!-- TABLE TITLE DEFINITION -->
	<ng-template pTemplate="caption">
		<div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title" [ngClass]="{'custom-title-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-title-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			{{ 'control-panel.maintenance-plans.maintenancePlansTable' | translate }}
		</div>
	</ng-template>

	<!-- TABLE COLUMN DEFINITION -->
	<ng-template pTemplate="header">
		<tr [ngClass]="{'custom-header-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-header-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
			<!-- EXPAND -->
			<th class="button-column"></th>

			<!-- SELECT -->
			<th class="checkbox-column">
				<div class="d-flex justify-content-center">
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</div>
			</th>

			<!-- NAME -->
			<th pSortableColumn="name">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'general.name' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="name"></p-sortIcon>
						<p-columnFilter
							field="name"
							type="text"
							matchMode="contains"
							placeholder="{{ 'general.search' | translate }}"
							display="menu"
							[showMatchModes]="false"
							[showOperator]="false"
							[showAddButton]="false"
						></p-columnFilter>
					</div>
				</div>
			</th>

			<!-- ACTIVE -->
			<th pSortableColumn="enabled">
				<div class="d-flex align-items-center h-100">
					<!-- COLUMN TITLE -->
					<div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
						{{ 'general.active' | translate }}
					</div>

					<!-- COLUMN SORT && FILTER ICONS -->
					<div class="d-flex align-items-center h-100">
						<p-sortIcon field="enabled"></p-sortIcon>
						<p-columnFilter field="enabled" type="boolean" display="menu" [showApplyButton]="false">
							<ng-template pTemplate="filter" let-filter="filterCallback">
								<p-select [options]="optionsdeleted" placeholder="{{ 'general.search' | translate }}"
									(onChange)="filter($event.value)">
									<ng-template let-option pTemplate="item">
										<span [ngClass]="'p-ml-1 state-' + option.value">
											{{ option.label }}
										</span>
									</ng-template>
								</p-select>
							</ng-template>
						</p-columnFilter>
					</div>
				</div>
			</th>
		</tr>
	</ng-template>

	<!-- TABLE BODY -->
	<ng-template pTemplate="body" let-maintenancePlan let-expanded="expanded">
		<tr class="p-selectable-row custom-rows" [ngClass]="{'custom-rows-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-rows-medium': authenticationService?.user?.fontSize === 'MEDIUM'}" (dblclick)="editPlanDialog(maintenancePlan)">
			<!-- EXPAND -->
			<td class="button-column">
				<div class="d-flex align-items-center justify-content-center">
					<button class="btn custom-expand-button" type="button" [pRowToggler]="maintenancePlan">
						<svg-icon
							[ngClass]="{ rotated: !expanded }"
							class="d-flex m-0 p-0 custom-expand-button-icon"
							src="assets/icons/select-down.svg"
							[svgStyle]="{ 'height.px': 20, 'width.px': 20 }"
						></svg-icon>
					</button>
				</div>
			</td>

			<!-- SELECT -->
			<td>
				<div class="d-flex justify-content-center">
					<p-tableCheckbox [value]="maintenancePlan"></p-tableCheckbox>
				</div>
			</td>

			<!-- NAME -->
			<td>
				{{ maintenancePlan.name }}
			</td>

			<!-- ACTIVE -->
			<td>
				<div class="d-flex justify-content-center align-items-center">
					<i
						class="pi"
						[ngClass]="{
							'true-icon pi-check-circle': maintenancePlan.enabled,
							'false-icon pi-times-circle': !maintenancePlan.enabled,
						}"
					></i>
				</div>
			</td>
		</tr>
	</ng-template>

	<!-- EXPANSION TEMPLATE -->
	<ng-template pTemplate="expandedrow" let-plan>
		<tr>
			<td colspan="4">
				<app-maintenances-view-list [parentMaintenancePlan]="plan"></app-maintenances-view-list>
			</td>
		</tr>
	</ng-template>

	<!-- TABLE EMPTY MESSAGE -->
	<ng-template pTemplate="emptymessage">
		<tr>
			<td colspan="4" class="p-0">
				<div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
					{{ 'table.tableEmptyMessage' | translate }}!
				</div>
			</td>
		</tr>
	</ng-template>

	<!-- FOOTER -->
	<ng-template pTemplate="footer">
		<tr>
			<td colspan="4" class="p-0">
				<div class="d-flex flex-row align-items-center p-3 gap-3">
					<!-- ADD MAINTENANCE PLAN BUTTON -->
					<app-table-add-button
						[text]="'control-panel.maintenance-plans.maintenancePlan' | translate"
						(btnClick)="create()"
						[isDisabled]="!user.isAdmin && !user.canManageMaintenancePlans"
					></app-table-add-button>

					<!-- CHANGE STATUS BUTTON -->
					<app-table-change-status-button
						(btnClick)="changeStatus()"
						[isDisabled]="(!user.isAdmin && !user.canManageMaintenancePlans) || selectedEntities.length === 0"
					></app-table-change-status-button>
				</div>
			</td>
		</tr>
	</ng-template>
</p-table>

<!-- CHANGE STATUS DIALOG -->
@if (showStatusDialog) {
	<div>
		<app-change-status-dialog
			[items]="'control-panel.statusDialog.maintenancePlans' | translate"
			[display]="true"
			[service]="maintenancePlanService"
			[entitiesList]="selectedEntities"
			(return)="refreshList($event)"
			(close)="closeStatusDialog($event)"
		></app-change-status-dialog>
	</div>
}

<!-- MAINTENANCE PLAN FORM -->
<app-maintenance-plan-form></app-maintenance-plan-form>
